"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("./internal/tslib.js");
/** @deprecated Import from ./core/streaming instead */
tslib_1.__exportStar(require("./core/streaming.js"), exports);
//# sourceMappingURL=streaming.js.map